import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

export default async ({ Vue }) => {
  const bugsnagClient = Bugsnag.start({
    apiKey: 'ca89d8d67136ee6e96672ea377fc442e',
    appVersion: `${process.env.VERSION}-${process.env.NODE_ENV}-${process.env.TERMINALID}`,
    releaseStage: process.env.NODE_ENV,
    // notifyReleaseStages: ['production'],
  });

  bugsnagClient.getPlugin(BugsnagPluginVue, Vue);

  Vue.prototype.$bugsnag = bugsnagClient;
};
